export class GetMessages {
    static readonly type = '[Messages] GetMessages';
    constructor(public dealId: number) {}
}

export class CreateMessage {
    static readonly type = '[Messages] CreateMessage';
    constructor(public dealId: number, public description: string) {}
}

export class CreateMessageReply {
    static readonly type = '[Messages] CreateMessageReply';
    constructor(public dealId: number, public taskId: number, public description: string) {}
}

export class ClearMessagesStore {
    static readonly type = '[Messages] ClearMessagesStore {';
    constructor() {}
}
